import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/shared/services/http/user/user.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/shared/services/util/util.service';



@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  footerLinks: any[] = [];
  _id: string = ""



  constructor(private service: UserService, private fb: FormBuilder, private utilService:UtilService) {

  }

  ngOnInit(): void {
    // this.footer()

  }
  footer() {
    this.service.footerPage().subscribe({
      next: (res) => {
      this.footerLinks = res.data;
      // console.log("fiooooooooooooooooooooootttttttteeeeeeeerrrrrrrr",this.footerLinks)
    },error: (err:any)=>{
      this.utilService.showErrorDialog({
        msg: err?.error?.message
      });
    }
  });

  }




}


